import { IAccount } from '../../../model/1GXCoding/IAccount';
import { ICostCenter } from '../../../model/1GXCoding/ICostCenter';
import { IFund } from '../../../model/1GXCoding/IFund';
import { IInternalOrder } from '../../../model/1GXCoding/IInternalOrder';
import { ICostingActivity } from '../../../model/domainServices/ICostingActivity';
import { ICrewType } from '../../../model/domainServices/ICrewType';
import { IFireNumber } from '../../../model/domainServices/IFireNumber';
import { IRateType } from '../../../model/domainServices/IRateType';
import { IRateUnit } from '../../../model/domainServices/IRateUnit';
import { FlyingDetailCRUD } from '../../../operations/FlyingDetailCRUD';
import { IArrayOption } from '../../../model/IArrayOption';

export interface IDomainData {
  fireNumbers: IFireNumber[];
  costingActivities: ICostingActivity[];
  rateTypes: IRateType[];
  crewTypes: ICrewType[];
  rateUnits: IRateUnit[];
  internalOrders: IInternalOrder[];
  costCenters: ICostCenter[];
  funds: IFund[];
  accounts: IAccount[];
}

export interface IDomainDataOptions {
  fireNumberOptions: IArrayOption[];
  crewTypeOptions: IArrayOption[];
  costingActivityOptions: IArrayOption[];
  rateTypeOptions: IArrayOption[];
  rateUnitOptions: IArrayOption[];
  internalOrderOptions: IArrayOption[];
  costCenterOptions: IArrayOption[];
  fundOptions: IArrayOption[];
  accountOptions: IArrayOption[];
}
export const getFlyingHoursDomainData = async (token: string, flightReportDate: string = new Date().toDateString()): Promise<IDomainData> => {
  const fireNumbersCall = FlyingDetailCRUD.getFireNumbers(flightReportDate, '', token);
  const crewTypesCall = FlyingDetailCRUD.getCrewTypes(flightReportDate, '');
  const costingActivityCall = FlyingDetailCRUD.getCostingActivities('', 1000);
  const rateTypeCall = FlyingDetailCRUD.getRateTypes(flightReportDate, '', 1000);
  const rateUnitCall = FlyingDetailCRUD.getRateUnits(flightReportDate, '', 1000);
  const internalOrderCall = FlyingDetailCRUD.getInternalOrder('', token);
  const costCenterCall = FlyingDetailCRUD.getCostCenter('', token);
  const fundCall = FlyingDetailCRUD.getFund('', token);
  const accountCall = FlyingDetailCRUD.getAccount('', token);

  const [fireNumbers, crewTypes, costingActivities, rateTypes, rateUnits, internalOrders, costCenters, funds, accounts] = await Promise.all([
    fireNumbersCall,
    crewTypesCall,
    costingActivityCall,
    rateTypeCall,
    rateUnitCall,
    internalOrderCall,
    costCenterCall,
    fundCall,
    accountCall,
  ]);

  return {
    fireNumbers: fireNumbers.data.data,
    costingActivities: costingActivities.data.data,
    rateTypes: rateTypes.data.data,
    crewTypes: crewTypes.data.data,
    rateUnits: rateUnits.data.data,
    internalOrders: internalOrders.data.data,
    costCenters: costCenters.data.data,
    funds: funds.data.data,
    accounts: accounts.data.data,
  };
};
